'use strict';

exports.__esModule = true;
exports.getVideoUrl = getVideoUrl;
exports.getVideoIdFromUrl = getVideoIdFromUrl;
function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://www.facebook.com/';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  var urlRegex = /facebook\.com\/(.+\/videos\/[A-Za-z0-9._%-]*)/gi;
  var match = urlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}
//# sourceMappingURL=facebookVideoUtils.js.map